import { useEffect } from 'react';

const DEFAULT_TITLE = "Sereno Spa | Luxury Spa & Wellness Center in Livingston Manor, NY";
const DEFAULT_DESC = "Experience ultimate relaxation at Sereno Spa. Professional facials, hair removal, lashes & brows, massage, and wellness treatments in Livingston Manor, New York.";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_fe1c91c4-a8c1-49c7-93bd-706bc696132c/artifacts/yn6qr8bb_IMG_6344.JPG";

function setMeta(property, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

const SEOHead = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESC,
  canonical,
  ogTitle,
  ogDescription,
  ogImage = DEFAULT_IMAGE
}) => {
  // Effect 1: Document title & meta description
  useEffect(() => {
    document.title = title;
    setMeta('description', description);
  }, [title, description]);

  // Effect 2: Canonical URL
  useEffect(() => {
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }
  }, [canonical]);

  // Effect 3: Open Graph tags
  useEffect(() => {
    setMeta('og:title', ogTitle || title, true);
    setMeta('og:description', ogDescription || description, true);
    setMeta('og:image', ogImage, true);
    setMeta('og:type', 'website', true);
    if (canonical) {
      setMeta('og:url', canonical, true);
    }
  }, [title, description, canonical, ogTitle, ogDescription, ogImage]);

  // Effect 4: Twitter & robots (static, runs once)
  useEffect(() => {
    setMeta('twitter:card', 'summary_large_image');
    setMeta('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    setMeta('googlebot', 'index, follow');
  }, []);

  // Effect 5: Twitter dynamic tags
  useEffect(() => {
    setMeta('twitter:title', ogTitle || title);
    setMeta('twitter:description', ogDescription || description);
    setMeta('twitter:image', ogImage);
  }, [title, ogTitle, description, ogDescription, ogImage]);

  return null;
};

export default SEOHead;
